<div mat-dialog-title class="flex flex-row items-center justify-between gap-4">
  <div i18n>Схема импорта файла csv</div>
  <button mat-icon-button [mat-dialog-close]="undefined">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <form [formGroup]="csvSchemaFormGroup" class="flex flex-col items-stretch justify-center gap-3">
    <mat-form-field appearance="outline" class="dense-input no-subscript">
      <mat-label i18n>Название схемы</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="dense-input no-subscript">
      <mat-label i18n>Разделитель столбцов</mat-label>
      <mat-select formControlName="separator">
        <mat-option value=";">;</mat-option>
        <mat-option value=",">,</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="dense-input no-subscript">
      <mat-label i18n>Импортировать со строки</mat-label>
      <input matInput formControlName="startImportIndex" type="number" cslDisableInputSpinEvents [min]="0" />
      <mat-icon
        matSuffix
        i18n-matTooltip
        matTooltip="Установите значение, если требуется чтобы импорт из файла csv начинался с определенной строки.
       По умолчанию значение 0 - импорт с начала файла. Индексирование строк начинается с нуля"
        >help_outline</mat-icon
      >
    </mat-form-field>

    <mat-form-field appearance="outline" class="dense-input no-subscript">
      <mat-label i18n>Кодировка файла</mat-label>
      <mat-select formControlName="encoding">
        <mat-option [value]="csvEncodingEnum.Utf8Bom" i18n>UTF8 с BOM</mat-option>
        <mat-option [value]="csvEncodingEnum.Utf8" i18n>UTF8</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="flex flex-row justify-between items-center">
  <button i18n mat-raised-button class="mat-accent" (click)="editColumnFields()">Столбцы таблицы</button>

  <div class="flex flex-row items-center">
    <button i18n mat-raised-button class="mat-accent" (click)="saveAndClose()" [disabled]="csvSchemaFormGroup.invalid"
      >ОК</button
    >
    <button i18n mat-button [mat-dialog-close]="undefined">ОТМЕНА</button>
  </div>
</div>
